import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
import Vue from 'vue'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import Vuelidate from 'vuelidate';
import Axios from 'axios';
import vueIziToast from 'vue-izitoast';
import Loading from 'vue-loading-overlay';
import store from './store';
import Permissions from './mixins/Permissions';
import VuexPersistence from 'vuex-persist';
import { VueMaskDirective } from 'v-mask';
import vSelect from 'vue-select';
import datePicker from 'vue-bootstrap-datetimepicker';
//import 'bootstrap/dist/css/bootstrap.css';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(datePicker);
Vue.use(vueIziToast);
Vue.use(datePicker);
Vue.use(Loading, {
  color: 'blue'
});
Vue.use(Vuex);
Vue.mixin(Permissions);
Vue.directive('mask', VueMaskDirective);

Vue.component('v-select', vSelect)

export const axiosInstance = new Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60000
})

export const api = axiosInstance;

Vue.prototype.$api = api;

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage
})

store.plugins = [vuexLocal.plugin]

const _store = new Vuex.Store(store);

Vue.config.devtools = true


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  store: _store,
  components: {
    App
  }
});
